module.exports = __webpack_public_path__ + "static/media/phone-504.cc9cba16.svg";